'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var DEFAULT_BUTTON_COLOR = '#FF45C3';
var DEFAULT_CONTENT_COLOR = 'white';

exports.DEFAULT_BUTTON_COLOR = DEFAULT_BUTTON_COLOR;
exports.DEFAULT_CONTENT_COLOR = DEFAULT_CONTENT_COLOR;
